export const eventsKey = 'events';
export const eventsInterviewKey = 'eventsInterview';
